import p1 from "../Assets/p1.PNG";
import p2 from "../Assets/p2.PNG";
import p3 from "../Assets/p3.PNG";
import p4 from "../Assets/p4.PNG";
import p5 from "../Assets/p5.PNG";
import p6 from "../Assets/p6.PNG";
import p7 from "../Assets/p7.png";
import p8 from "../Assets/p8.PNG";
import p9 from "../Assets/p9.PNG";
import p10 from "../Assets/p10.PNG";
import p11 from "../Assets/p11.PNG";
import p12 from "../Assets/p12.PNG";
import p13 from "../Assets/p13.PNG";
import p14 from "../Assets/p14.png";
import p15 from "../Assets/p15.PNG";
import p16 from "../Assets/p16.png";
import p17 from "../Assets/p17.png";
import p18 from "../Assets/p18.png";
import p19 from "../Assets/p19.png";
//inductions
import one from "../Assets/one.png";
import two from "../Assets/two.png";
import i1 from "../Assets/i1.png";
import i2 from "../Assets/i2.png";
import i3 from "../Assets/i3.png";
import i4 from "../Assets/i4.png";
import i5 from "../Assets/i5.png";
import i6 from "../Assets/i6.png";
import i7 from "../Assets/i7.png";

export const productData = [
  {
    img: p1,
    name: "WREN 60",
    features: [
      "Soft Push Button",
      "Black Finish",
      "Baffle Filter",
      "LED Light",
      "Air Flow up to 1100m3/hr",
      "Available Size: 60cm",
      "Dimensions: W*H*D",
      "Upper: 210*390*175 mm",
      "Lower: 600*45*490 mm",
    ],
  },
  {
    img: p2,
    name: "Duck 60",
    features: [
      "Soft Push Button",
      "Black Finish",
      "Baffle Filter",
      "LED Light",
      "Air Flow up to 1150m3/hr",
      "Available Size: 60cm",
      "Dimensions: W*H*D",
      "Upper: 270*400*270 mm",
      "Lower: 600*60*420 mm",
    ],
  },
  {
    img: p3,
    name: "Duck Plus 60",
    features: [
      "Touch with Motion Sensor Technology",
      "Black Finish",
      "Baffle Filter",
      "LED Light",
      "Air Flow up to 1200m3/hr",
      "Available Size: 60cm",
      "Inside Oil Collector",
      "Dimensions: W*H*D",
      "Upper: 270*400*270 mm",
      "Lower: 600*60*420 mm",
    ],
  },
  {
    img: p4,
    name: "Hawk 60",
    features: [
      "Touch with Motion Sensor Technology",
      "Black Finish",
      "Baffle Filter",
      "LED Light",
      "Air Flow up to 1250m3/hr",
      "Available Size: 60cm",
      "Outside Oil Collector",
      "Dimensions: W*H*D",
      "Upper: 350*410*300 mm",
      "Lower: 600*110*480 mm",
    ],
  },
  {
    img: p5,
    name: "Hawk 90",
    features: [
      "Touch with Motion Sensor Technology",
      "Black Finish",
      "Baffle Filter",
      "LED Light",
      "Air Flow up to 1450m3/hr",
      "Available Size: 60cm",
      "Outside Oil Collector",
      "Dimensions: W*H*D",
      "Upper: 350*410*300 mm",
      "Lower: 900*110*480 mm",
    ],
  },
  {
    img: p6,
    name: "SWALLOW 60/75",
    features: [
      "Touch with Motion Sensor Technology",
      "Black Finish",
      "Baffle Filter",
      "LED Light",
      "Air Flow up to 1350m3/hr / 1450m3/hr",
      "Available Size: 60cm / 75cm",
      "Outside Oil Collector",
      "Dimensions: W*H*D",
      "Upper: 360*410*280 mm",
      "Lower: 600* / 740*100*400 mm",
    ],
  },
  {
    img: p7,
    name: "Swallow 90",
    features: [
      "Touch with Motion Sensor Technology",
      "Black Finish",
      "Baffle Filter",
      "LED Light",
      "Air Flow up to 1550m3/hr",
      "Available Size: 90cm",
      "Outside Oil Collector",
      "Dimensions: W*H*D",
      "Upper: 360*410*280 mm",
      "Lower: 900*110*400 mm",
    ],
  },
  {
    img: p8,
    name: "PELICAN 90",
    features: [
      "Touch with Motion Sensor Technology",
      "Black Finish",
      "Baffle Filter",
      "LED Light",
      "Air Flow up to 1650m3/hr",
      "Available Size: 90cm",
      "Outside Oil Collector",
      "Dimensions: W*H*D",
      "Upper: 360*430*280 mm",
      "Lower: 870*80*470 mm",
    ],
  },
  {
    img: p9,
    name: "FLAMINGO 60",
    features: [
      "Touch with Motion Sensor Technology",
      "Black Finish",
      "Baffle Filter",
      "LED Light",
      "Air Flow up to 1550m3/hr",
      "Available Size: 60cm",
      "Outside Oil Collector",
      "Dimensions: W*H*D",
      "Upper: 320*450*300 mm",
      "Lower: 600*430*360 mm",
    ],
  },
  {
    img: p10,
    name: "FLAMINGO 90",
    features: [
      "Touch with Motion Sensor Technology",
      "Black Finish",
      "Baffle Filter",
      "LED Light",
      "Air Flow up to 2020m3/hr",
      "Available Size: 90cm",
      "Outside Oil Collector",
      "Dimensions: W*H*D",
      "Upper: 320*450*300 mm",
      "Lower: 900*430*360 mm",
    ],
  }, {
    img: p11,
    name: "SPARROW 90",
    features: [
      "Touch with Motion Sensor Technology",
      "Black Finish",
      "Baffle Filter",
      "LED Light",
      "Air Flow up to 1550m3/hr",
      "Available Size: 90cm",
      "Outside Oil Collector",
      "Dimensions: W*H*D",
      "Upper: 400*520*325 mm",
      "Lower: 00*80*360 mm",
    ],
  }, {
    img: p12,
    name: "WOODPEAKER CURVEY 90",
    features: [
      "Touch with Motion Sensor Technology",
      "Black Finish",
      "Baffle Filter",
      "LED Light",
      "Air Flow up to 1650m3/hr",
      "Available Size: 90cm",
      "Outside Oil Collector",
      "Dimensions: W*H*D",
      "Upper: 380*500*325 mm",
      "Lower: 80*880*450 mm",
    ],
  }, {
    img: p13,
    name: "WOODPEAKER 3D 90",
    features: [
      "Touch with Motion Sensor Technology",
      "Black Finish",
      "Baffle Filter",
      "LED Light",
      "Air Flow up to 1550m3/hr",
      "Available Size: 90cm",
      "Outside Oil Collector",
      "Dimensions: W*H*D",
      "Upper: 360*410*280 mm",
      "Lower: 900*110*400 mm",
    ],
  },
  {
    img: p14,
    name: "WOODPEAKER SLIM 60/90",
    features: [
      "Touch with Motion Sensor Technology",
      "Black Finish",
      "Baffle Filter",
      "LED Light",
      "Air Flow up to 1350m3/hr",
      "Available Size: 60cm/90cm",
      "Outside Oil Collector",
      "Dimensions: W*H*D",
      "Upper: 385*440*305 mm",
      "Lower: 600* / 900* 190*390 mm",
    ],
  },
  {
    img: p15,
    name: "WOODPEAKER 90",
    features: [
      "Touch with Motion Sensor Technology",
      "Black Finish",
      "Baffle Filter",
      "LED Light",
      "Air Flow up to 1350m3/hr",
      "Available Size: 90cm",
      "Outside Oil Collector",
      "Dimensions: W*H*D",
      "Upper: 380*500*325 mm",
      "Lower: 80*900*450 mm",
    ],
  },
  {
    img: p16,
    name: "WOODPEAKER PRIME 60/75/90",
    features: [
      "Touch with Motion Sensor Technology",
      "Black Finish",
      "Baffle Filter",
      "LED Light",
      "Air Flow up to 1350m3/hr / 1550m3/hr / 1650m3/hr",
      "Available Size: 60cm/75cm/90cm",
      "Outside Oil Collector",
      "Dimensions: W*H*D",
      "Upper: 360*470*285 mm",
      "Lower: 600*/ 750* / 900* 80*450 mm",
    ],
  },
  {
    img: p17,
    name: "WOODPEAKER PRIME ECO 60/75/90",
    features: [
      "Touch with Motion Sensor Technology",
      "Black Finish",
      "Baffle Filter",
      "LED Light",
      "Air Flow up to 1350m3/hr / 1550m3/hr",
      "Available Size: 60cm/90cm",
      "Outside Oil Collector",
      "Dimensions: W*H*D",
      "Upper: 385*440*305 mm",
      "Lower: 600* / 900* 80*390 mm",
    ],
  },
  {
    img: p18,
    name: "WOODPEAKER PLUS 90",
    features: [
      "Touch with Motion Sensor Technology",
      "Black Finish",
      "Baffle Filter",
      "LED Light",
      "Air Flow up to 1650m3/hr",
      "Available Size: 90cm",
      "Outside Oil Collector",
      "Dimensions: W*H*D",
      "Upper: 385*430*310 mm",
      "Lower: 900*80*390 mm",
    ],
  },
  {
    img: p19,
    name: "WOODPEAKER BLDC 60 / 90",
    features: [
      "Touch with Motion Sensor Technology",
      "Black Finish",
      "Baffle Filter",
      "LED Light",
      "9 Speed Control / Higher RPM",
      "Air Flow up to 1650m3/hr",
      "Available Size: 60cm/90cm",
      "Outside Oil Collector",
      "Dimensions: W*H*D",
      "Upper: 360*470*285 mm",
      "Lower: 600*/ 750* / 900* 80*450 mm",
    ],
  },
];


export const inductionProducts = [
  {
    img: one,
    p: "Non - Stick Coated inner tank less oil"
  },
  {
    img: two,
    p: "Detachable power card"
  },
  {
    img: i1,
    name : "3 BNR HOB",
    features:[
      "Finish : Black Tempered Glass",
      "Ignition : Auto / Manual",
      "Glass Thickness : 8mm",
      "Size : 750*510 mm"
    ]
  },
  {
    img: i2,
    name : "3 BNR HOB",
    features:[
      "Finish : Black Tempered Glass",
      "Ignition : Auto / Manual",
      "Glass Thickness : 7mm",
      "Size : 770*400 mm"
    ]
  },
  {
    img: i3,
    name : "2 BRN COOK TOP",
    features:[
      "Finish : Black Tempered Glass",
      "Ignition : Auto / Manual",
      "Glass Thickness : 7mm",
      "Size : 575*290 mm"
    ]
  },
  {
    img: i4,
    name : "3 BRN COOK TOP",
    features:[
      "Finish : Black Tempered Glass",
      "Ignition : Auto / Manual",
      "Glass Thickness : 7mm",
      "Size : 770*380 mm"
    ]
  }, {
    img: i5,
    name : "4 BRN COOK TOP",
    features:[
      "Finish : Black Tempered Glass",
      "Ignition : Auto / Manual",
      "Glass Thickness : 7mm",
      "Size : 575*580 mm"
    ]
  }, {
    img: i6,
    name : "3 BRN HOB TOP",
    features:[
      "Finish : Black Tempered Glass",
      "Ignition : Auto / Manual",
      "Glass Thickness : 7mm",
      "Size : 770*400 mm"
    ]
  }, {
    img: i7,
    name : "4 BRN HOB TOP",
    features:[
      "Finish : Black Tempered Glass",
      "Ignition : Auto / Manual",
      "Glass Thickness : 7mm",
      "Size : 790*450 mm"
    ]
  },
]